export enum NullDateRangeDateBehavior {
    USE_CURRENT_DATE = "useCurrentDate",
    USE_OTHER_DATE = "useOtherDate",
    UNBOUND = "unbound",
}
